import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../app.service';
import { isArrayWithData } from '../../utilities/array.helpers';

@Component({
    selector: 'parent-dashboard',
    templateUrl: './parent-dashboard.component.html',
    styleUrls: ['./parent-dashboard.component.css'],
})
export class ParentDashboardComponent implements OnInit {
    menuItems: any[] = [];
    childMenus: any[] = [];
    displayText: string = '';
    displayIcon: string = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private appService: AppService,
    ) {}

    ngOnInit() {
        if (this.appService.navigationNodes?.length) {
            this.menuItems = this.mapMenuItems(this.appService.navigationNodes);

            this.setChildMenus();
        } else {
            this.appService.getNavigationNodes().subscribe((nodes: any) => {
                this.menuItems = this.mapMenuItems(nodes);

                this.setChildMenus();
            });
        }

        this.route.queryParamMap.subscribe(() => {
            this.setChildMenus();
        });
    }

    setChildMenus() {
        const parentPath = this.route.snapshot.queryParamMap.get('path');

        if (!parentPath || !this.menuItems?.length) {
            this.childMenus = [];
            return;
        }

        const parentNode = this.findNodeByPath(this.menuItems, parentPath);

        this.displayText = parentNode?.DisplayText || '';
        this.displayIcon = parentNode?.MatIconName || '';

        this.childMenus = parentNode?.children || [];
    }

    toSlug(text: string): string {
        return text
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '');
    }

    public getSelectedNodePath(node: any): string {
        let path = this.toSlug(node.DisplayText);

        let parent = node?.parent;

        while (parent?.DisplayText) {
            path = `${this.toSlug(parent.DisplayText)}/${path}`;

            parent = parent?.parent;
        }

        return path;
    }

    findNodeByPath(nodes: any[], path: string, parentPath: string = ''): any {
        for (const node of nodes) {
            const currentPath = parentPath
                ? `${parentPath}/${this.toSlug(node.DisplayText)}`
                : this.toSlug(node.DisplayText);

            if (currentPath === path) {
                return node;
            }

            if (node.children?.length) {
                const found = this.findNodeByPath(
                    node.children,
                    path,
                    currentPath,
                );

                if (found) {
                    return found;
                }
            }
        }

        return null;
    }

    private mapMenuItems(nodes: any[]): any[] {
        if (!isArrayWithData(nodes)) {
            return [];
        }

        return nodes
            .filter((node) => !!node)
            .map((node: any) => ({
                NavigationNodeId: node.NavigationNodeId,
                Name: node.Name,
                Description: node.Description,
                DisplayText: node.DisplayText,
                RoutePath: node.RoutePath,
                MatIconName: node.MatIconName,
                PrimeNgIconName: node.PrimeNgIconName,

                expanded: false,

                children: this.mapMenuItems(
                    (node.NavigationNodes || []).filter(
                        (child: any) => !!child,
                    ),
                ),
            }));
    }

    navigateChild(child: any) {
        // If child has sub-children
        if (child?.children?.length) {
            const childPath = this.buildPath(child);

            this.router.navigate(['menu-dashboard'], {
                queryParams: {
                    path: childPath,
                },
            });

            return;
        }

        // Final route node
        if (child?.RoutePath) {
            this.router.navigate(['/' + child.RoutePath]);
        }
    }

    buildPath(
        targetNode: any,
        nodes: any[] = this.menuItems,
        parentPath: string = '',
    ): string {
        for (const node of nodes) {
            const currentPath = parentPath
                ? `${parentPath}/${this.toSlug(node.DisplayText)}`
                : this.toSlug(node.DisplayText);

            if (node === targetNode) {
                return currentPath;
            }

            if (node.children?.length) {
                const found = this.buildPath(
                    targetNode,
                    node.children,
                    currentPath,
                );

                if (found) {
                    return found;
                }
            }
        }

        return '';
    }
}
